import { useQuery } from "@tanstack/react-query";
import { getSupplierWarehouses } from "../../../services/supplierOrderService";

export const useSupplierWarehouses = () => {

  return useQuery({
    queryKey: ["supplier-warehouses"],
    queryFn: getSupplierWarehouses,
    staleTime: 1000 * 60 * 10,
  });

};
